import { chunk } from 'lodash-es';
import FeaturesItem from './FeaturesItem';

const renderItems = items =>
  chunk(items, 100).map((item, key) => (
    <div className="row" key={key}>
      {item.map((el, key) => (
        <FeaturesItem {...el} key={key} />
      ))}
    </div>
  ));

const FeaturesList = ({ id, title, items, itemRef }) => (
  <section
    className={`section section_features_${id + 2} anchor_target`}
    id={id}
    ref={itemRef}
  >
    <div className="wrapper">
      <h3 className="title section__main-title _mb-36 _mb-laptop-20">
        {title}
      </h3>
      {renderItems(items)}
    </div>
  </section>
);

export default FeaturesList;
